import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('fcFwdCkuCustStore', Object.keys(getters)),
	...mapState('fcFwdCkuCustStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('fcFwdCkuCustStore', Object.keys(actions)),
	...mapMutations('fcFwdCkuCustStore', Object.keys(mutations))
};
